import type { MagnoliaPageNode, Props } from '@/types/cms/magnolia';
import AlbConfigModel from '@/Config/AlbConfigModel';
import { Apis, logger, LogLevel, PUBLIC_CONFIG_NODE_PATH } from '@/Util/globals';
import { apiFetch, getCacheHeaders } from '@/Util/api';
import { getRequestConfig404 } from '@/Util/magnoliaData/getRequestConfig404';
import { ReadonlyURLSearchParams } from 'next/navigation';

export const fetchMagnoliaDataFor404 = async (
  apis: Apis,
  searchParams: ReadonlyURLSearchParams,
  isProduction: boolean,
  logLevel: LogLevel,
  isAuthorString?: string,
  magnoliaApiBase?: string,
  magnoliaHost?: string,
  magnoliaHostClient?: string
): Promise<Props> => {
  const { magnoliaContext, rootNodePath, locale, siteConfig, isAuthor, resolvedUrl, fetchTTL } =
    await getRequestConfig404(apis, searchParams, isAuthorString);
  let page: MagnoliaPageNode | undefined;
  let albConfig: AlbConfigModel = new AlbConfigModel();
  let translationsVersion: string = '0';
  const errorPage404 = siteConfig.parameters.errorPage404;
  if (errorPage404) {
    try {
      const pageData404Response = await apiFetch(
        apis.pages + errorPage404 + magnoliaContext.search,
        undefined,
        isAuthor,
        fetchTTL
      );
      page = await pageData404Response.json();
    } catch (err) {
      logger('error')('ErrorPage404 not found: ', err);
    }
    try {
      const albConfigResponse = await apiFetch(
        apis.config + PUBLIC_CONFIG_NODE_PATH,
        undefined,
        isAuthor,
        fetchTTL
      );
      if (albConfigResponse) {
        albConfig = await albConfigResponse.json();
      }
    } catch (err) {
      logger('debug')('Config for 404 page not found');
    }
    try {
      const translationsVersionResponse = await fetch(apis.translationsVersion, {
        ...getCacheHeaders(isAuthor, undefined, fetchTTL)
      });
      if (translationsVersionResponse) {
        translationsVersion = await translationsVersionResponse.text();
      }
    } catch (err) {
      logger('error')('Unable to fetch translationVersion');
    }
  } else {
    logger('error')('errorPage404 is not defined in site config.');
  }

  return {
    magnoliaContext,
    rootNodePath,
    page: page!,
    siteConfig,
    locale,
    albConfig,
    translationsVersion,
    magnoliaApiBase: magnoliaApiBase || '',
    magnoliaHost: magnoliaHost || '',
    magnoliaHostClient: magnoliaHostClient || magnoliaHost || '',
    bvSrc: '',
    isProduction,
    is404: true,
    logLevel,
    isAuthor,
    resolvedUrl,
    currentHost: window.location.origin
  };
};
